export default function discount() {
  const getCurrentDiscount = (discounts) => {
    const index = discounts?.findIndex((d) => d.from_quantity === 1);
    if (index !== -1) {
      return discounts[index];
    }
    return null;
  };

  return {
    getCurrentDiscount,
  };
}
